import { useState, useCallback } from 'react';
import { loadFilters } from '@/shared/utils/filterStorage';
import { DeliveryHistoryDetailFilters } from '../types/deliveryHistoryDetail.types';
import { getDefaultFilters } from '../utils/deliveryHistoryDetailHelpers';

export const FILTER_STORAGE_KEY = 'deliveryHistoryDetailFilters';

export const useDeliveryDetailFilter = () => {
    const [filters, setFilters] = useState<DeliveryHistoryDetailFilters>(() => {
        const saved = loadFilters<DeliveryHistoryDetailFilters>(FILTER_STORAGE_KEY);
        return saved || getDefaultFilters();
    });

    const handleFilterChange = useCallback(
        <K extends keyof DeliveryHistoryDetailFilters>(key: K, value: DeliveryHistoryDetailFilters[K]) => {
            setFilters((prev) => ({ ...prev, [key]: value }));
        },
        []
    );

    const resetFilters = useCallback(() => {
        setFilters(getDefaultFilters());
    }, []);

    return { filters, setFilters, handleFilterChange, resetFilters };
};
